import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCredits(credits: number): string {
  return credits.toLocaleString()
}

export function formatPrice(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`
}

export function formatDate(date: string | null): string {
  if (!date) return '-'
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

export function formatDateTime(date: string | null): string {
  if (!date) return '-'
  return new Date(date).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'completed':
      return 'text-green-600 bg-green-100'
    case 'processing':
      return 'text-blue-600 bg-blue-100'
    case 'pending':
      return 'text-yellow-600 bg-yellow-100'
    case 'failed':
      return 'text-red-600 bg-red-100'
    case 'cancelled':
      return 'text-gray-600 bg-gray-100'
    default:
      return 'text-gray-600 bg-gray-100'
  }
}

export function getPlanColor(plan: string): string {
  switch (plan) {
    case 'trial':
      return 'text-gray-600'
    case 'basic':
      return 'text-blue-600'
    case 'pro':
      return 'text-purple-600'
    case 'enterprise':
      return 'text-amber-600'
    default:
      return 'text-gray-600'
  }
}

export function truncate(text: string, length: number): string {
  if (text.length <= length) return text
  return text.slice(0, length) + '...'
}

const VIDEO_URL_REGEX = /\.(mp4|webm|mov)(\?|$)/i

export function isVideoUrl(url: string): boolean {
  return VIDEO_URL_REGEX.test(url)
}

const INVALID_MEDIA_URL_LITERALS = new Set([
  'none',
  'null',
  'undefined',
  'n/a',
  'na',
  'nan',
])

export function filterValidMediaUrls(urls: unknown[] | null | undefined): string[] {
  if (!Array.isArray(urls)) return []

  const seen = new Set<string>()
  const valid: string[] = []

  for (const raw of urls) {
    if (typeof raw !== 'string') continue

    const normalized = raw.trim()
    if (!normalized) continue
    if (INVALID_MEDIA_URL_LITERALS.has(normalized.toLowerCase())) continue

    if (!seen.has(normalized)) {
      seen.add(normalized)
      valid.push(normalized)
    }
  }

  return valid
}
